// extracted by mini-css-extract-plugin
module.exports = {"container":"Main-module--container--3vFTO"};